import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "iq-top-navbar" }
const _hoisted_3 = { class: "iq-navbar-custom" }
const _hoisted_4 = { class: "navbar navbar-expand-lg navbar-light p-0" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_7 = { class: "navbar-nav ml-auto navbar-list align-items-center" }
const _hoisted_8 = { class: "nav-item nav-icon dropdown caption-content" }
const _hoisted_9 = {
  class: "iq-sub-dropdown dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_10 = { class: "card shadow-none m-0" }
const _hoisted_11 = { class: "card-body p-0 text-center" }
const _hoisted_12 = { class: "p-3" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "d-flex align-items-center justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"iq-sidebar sidebar-default\"><div class=\"iq-sidebar-logo d-flex align-items-center justify-content-between\"><a href=\"/\" class=\"header-logo w-100 d-flex align-items-center justify-content-center\"><img src=\"assets/images/logo.jpeg\" class=\"img-fluid h-100\" alt=\"logo\"></a><div class=\"iq-menu-bt-sidebar ml-0\"><i class=\"las la-bars wrapper-menu\"></i></div></div><div class=\"data-scrollbar\" data-scroll=\"1\"><nav class=\"iq-sidebar-menu\"><ul id=\"iq-sidebar-toggle\" class=\"iq-menu\"><li class=\"active\"><a href=\"/\" class=\"svg-icon\"><svg class=\"svg-icon\" id=\"p-dash1\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z\"></path><polyline points=\"3.27 6.96 12 12.01 20.73 6.96\"></polyline><line x1=\"12\" y1=\"22.08\" x2=\"12\" y2=\"12\"></line></svg><span class=\"ml-4\">Dashboards</span></a></li><li class=\"\"><a href=\"#category\" class=\"collapsed\" data-toggle=\"collapse\" aria-expanded=\"false\"><svg class=\"svg-icon\" id=\"p-dash3\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"></rect><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"></path></svg><span class=\"ml-4\">Currencies</span><svg class=\"svg-icon iq-arrow-right arrow-active\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"10 15 15 20 20 15\"></polyline><path d=\"M4 4h7a4 4 0 0 1 4 4v12\"></path></svg></a><ul id=\"category\" class=\"iq-submenu collapse\" data-parent=\"#iq-sidebar-toggle\"><li class=\"\"><a href=\"/currencies\"><i class=\"las la-minus\"></i><span>Record Currencies</span></a></li><li class=\"\"><a href=\"/exchange-rate\"><i class=\"las la-minus\"></i><span>Exchange Rate</span></a></li><li class=\"\"><a href=\"/transactions\"><i class=\"las la-minus\"></i><span>Transactions</span></a></li><li class=\"\"><a href=\"/clients\"><i class=\"las la-minus\"></i><span>Clients</span></a></li></ul></li><li class=\"\"><a href=\"/reports\" class=\"\"><svg class=\"svg-icon\" id=\"p-dash7\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline points=\"10 9 9 9 8 9\"></polyline></svg><span class=\"ml-4\">Reports</span></a><ul id=\"reports\" class=\"iq-submenu collapse\" data-parent=\"#iq-sidebar-toggle\"></ul></li></ul></nav><br><br><br><br><div id=\"sidebar-bottom\" class=\"position-relative sidebar-bottom\"><div class=\"card border-none\"></div></div><div class=\"p-3\"></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"iq-navbar-logo d-flex align-items-center justify-content-between\"><i class=\"ri-menu-line wrapper-menu\"></i><a href=\"backend/index.html\" class=\"header-logo\"><img src=\"assets/images/logo.png\" class=\"img-fluid rounded-normal\" alt=\"logo\"><h5 class=\"logo-title ml-3\">POSDash</h5></a></div><div class=\"iq-search-bar device-search\"><form action=\"#\" class=\"searchbox\"><a class=\"search-link\" href=\"#\"><i class=\"ri-search-line\"></i></a><input type=\"text\" class=\"text search-input\" placeholder=\"Search here...\"></form></div>", 2)),
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("button", {
                class: "navbar-toggler",
                type: "button",
                "data-toggle": "collapse",
                "data-target": "#navbarSupportedContent",
                "aria-controls": "navbarSupportedContent",
                "aria-label": "Toggle navigation"
              }, [
                _createElementVNode("i", { class: "ri-menu-3-line" })
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("ul", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createStaticVNode("<li class=\"nav-item nav-icon dropdown\"><a href=\"#\" class=\"search-toggle dropdown-toggle btn border add-btn\" id=\"dropdownMenuButton02\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><img src=\"assets/images/small/flag-01.png\" alt=\"img-flag\" class=\"img-fluid image-flag mr-2\">En </a><div class=\"iq-sub-dropdown dropdown-menu\" aria-labelledby=\"dropdownMenuButton2\"><div class=\"card shadow-none m-0\"><div class=\"card-body p-3\"><a class=\"iq-sub-card\" href=\"#\"><img src=\"assets/images/small/flag-02.png\" alt=\"img-flag\" class=\"img-fluid mr-2\">French</a><a class=\"iq-sub-card\" href=\"#\"><img src=\"assets/images/small/flag-03.png\" alt=\"img-flag\" class=\"img-fluid mr-2\">Spanish</a><a class=\"iq-sub-card\" href=\"#\"><img src=\"assets/images/small/flag-04.png\" alt=\"img-flag\" class=\"img-fluid mr-2\">Italian</a><a class=\"iq-sub-card\" href=\"#\"><img src=\"assets/images/small/flag-05.png\" alt=\"img-flag\" class=\"img-fluid mr-2\">German</a><a class=\"iq-sub-card\" href=\"#\"><img src=\"assets/images/small/flag-06.png\" alt=\"img-flag\" class=\"img-fluid mr-2\">Japanese</a></div></div></div></li><li class=\"nav-item nav-icon search-content\"><a href=\"#\" class=\"search-toggle rounded\" id=\"dropdownSearch\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"ri-search-line\"></i></a><div class=\"iq-search-bar iq-sub-dropdown dropdown-menu\" aria-labelledby=\"dropdownSearch\"><form action=\"#\" class=\"searchbox p-2\"><div class=\"form-group mb-0 position-relative\"><input type=\"text\" class=\"text search-input font-size-12\" placeholder=\"type here to search...\"><a href=\"#\" class=\"search-link\"><i class=\"las la-search\"></i></a></div></form></div></li>", 2)),
                  _cache[5] || (_cache[5] = _createElementVNode("li", { class: "nav-item nav-icon dropdown" }, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "search-toggle dropdown-toggle",
                      id: "dropdownMenuButton2",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "feather feather-mail"
                      }, [
                        _createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
                        _createElementVNode("polyline", { points: "22,6 12,13 2,6" })
                      ]),
                      _createElementVNode("span", { class: "bg-primary" })
                    ]),
                    _createElementVNode("div", {
                      class: "iq-sub-dropdown dropdown-menu",
                      "aria-labelledby": "dropdownMenuButton2"
                    }, [
                      _createElementVNode("div", { class: "card shadow-none m-0" }, [
                        _createElementVNode("div", { class: "card-body p-0" }, [
                          _createElementVNode("div", { class: "cust-title p-3" }, [
                            _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                              _createElementVNode("h5", { class: "mb-0" }, "All Messages"),
                              _createElementVNode("a", {
                                class: "badge badge-primary badge-card",
                                href: "#"
                              }, "3")
                            ])
                          ]),
                          _createElementVNode("div", { class: "px-3 pt-0 pb-0 sub-card" }, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3 border-bottom" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/01.jpg",
                                    alt: "01"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Emma Watson"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "12 : 47 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3 border-bottom" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/02.jpg",
                                    alt: "02"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Ashlynn Franci"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "11 : 30 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/03.jpg",
                                    alt: "03"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Kianna Carder"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "11 : 21 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("a", {
                            class: "right-ic btn btn-primary btn-block position-relative p-2",
                            href: "#",
                            role: "button"
                          }, " View All ")
                        ])
                      ])
                    ])
                  ], -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("li", { class: "nav-item nav-icon dropdown" }, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "search-toggle dropdown-toggle",
                      id: "dropdownMenuButton",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        class: "feather feather-bell"
                      }, [
                        _createElementVNode("path", { d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" }),
                        _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
                      ]),
                      _createElementVNode("span", { class: "bg-primary" })
                    ]),
                    _createElementVNode("div", {
                      class: "iq-sub-dropdown dropdown-menu",
                      "aria-labelledby": "dropdownMenuButton"
                    }, [
                      _createElementVNode("div", { class: "card shadow-none m-0" }, [
                        _createElementVNode("div", { class: "card-body p-0" }, [
                          _createElementVNode("div", { class: "cust-title p-3" }, [
                            _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                              _createElementVNode("h5", { class: "mb-0" }, "Notifications"),
                              _createElementVNode("a", {
                                class: "badge badge-primary badge-card",
                                href: "#"
                              }, "3")
                            ])
                          ]),
                          _createElementVNode("div", { class: "px-3 pt-0 pb-0 sub-card" }, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3 border-bottom" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/01.jpg",
                                    alt: "01"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Emma Watson"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "12 : 47 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3 border-bottom" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/02.jpg",
                                    alt: "02"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Ashlynn Franci"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "11 : 30 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "iq-sub-card"
                            }, [
                              _createElementVNode("div", { class: "media align-items-center cust-card py-3" }, [
                                _createElementVNode("div", { class: "" }, [
                                  _createElementVNode("img", {
                                    class: "avatar-50 rounded-small",
                                    src: "assets/images/user/03.jpg",
                                    alt: "03"
                                  })
                                ]),
                                _createElementVNode("div", { class: "media-body ml-3" }, [
                                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between" }, [
                                    _createElementVNode("h6", { class: "mb-0" }, "Kianna Carder"),
                                    _createElementVNode("small", { class: "text-dark" }, [
                                      _createElementVNode("b", null, "11 : 21 pm")
                                    ])
                                  ]),
                                  _createElementVNode("small", { class: "mb-0" }, "Lorem ipsum dolor sit amet")
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("a", {
                            class: "right-ic btn btn-primary btn-block position-relative p-2",
                            href: "#",
                            role: "button"
                          }, " View All ")
                        ])
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("li", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("a", {
                      href: "#",
                      class: "search-toggle dropdown-toggle",
                      id: "dropdownMenuButton4",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }, [
                      _createElementVNode("img", {
                        src: "assets/images/user/1.png",
                        class: "img-fluid rounded",
                        alt: "user"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "media-body profile-detail text-center" }, [
                            _createElementVNode("img", {
                              src: "assets/images/logo.jpeg",
                              alt: "profile-bg",
                              class: "rounded-top img-fluid mb-4"
                            }),
                            _createElementVNode("img", {
                              src: "assets/images/user/1.png",
                              alt: "profile-img",
                              class: "rounded profile-img img-fluid avatar-70"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.user.email), 1),
                            _createElementVNode("p", _hoisted_14, " Since " + _toDisplayString(_ctx.formatDate(_ctx.user.created_at)), 1),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_router_link, {
                                to: "/user-profile",
                                class: "btn border mr-2"
                              }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createTextVNode("Profile")
                                ])),
                                _: 1
                              }),
                              _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                                class: "btn border"
                              }, " Sign Out ")
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_router_view, { name: "dashboard" })
    ]),
    _cache[10] || (_cache[10] = _createStaticVNode("<footer class=\"iq-footer\"><div class=\"container-fluid\"><div class=\"card\"><div class=\"card-body\"><div class=\"row\"><div class=\"col-lg-6\"><ul class=\"list-inline mb-0\"><li class=\"list-inline-item\"><a href=\"#\">Privacy Policy</a></li><li class=\"list-inline-item\"><a href=\"#\">Terms of Use</a></li></ul></div><div class=\"col-lg-6 text-right\"><span class=\"mr-1\"> © </span><a href=\"#\" class=\"\">Forex Bureau</a>. </div></div></div></div></div></footer>", 1))
  ], 64))
}